/* eslint-disable global-require */
const urljoin = require('url-join');
const configConstants = require('./config-constants');

let localConfig = {};
let oldLogoClubIds = [];
try {
    // eslint-disable-next-line
    localConfig = require('./config-local.js').default;
} catch (e) {
    console.log('No local overrides');
}
try {
    // eslint-disable-next-line
    oldLogoClubIds = require('./old-logo-club-ids.js').default;
} catch (e) {
    console.log('No old logo club ids');
}

const rootDomain = 'utrsports.net';
const brandedDomain = 'utrsports.net';
const twitterHandle = 'UTR_Sports_';

const defaultTitle = 'Tennis & Pickleball Ratings & Events | UTR Sports';

const devFontUrl = 'https://cloud.typography.com/6323816/6761592/css/fonts.css'; // doesn't count against production page views
const localFontUrl = '/fonts/utr-fonts.css'; // for internal/offline use
const prodFontUrl = 'https://cloud.typography.com/6323816/6355392/css/fonts.css';
const nextAppUrl = (env = 'prod') => `https://${env}-new-app.utrsports.net`;

const webServerPublicPath = '/';

const messaging = {
    pollingIntervalMin: 20000,
    pollingIntervalMax: 100000,
};

const messagingProd = {
    pollingIntervalMin: 60000,
    pollingIntervalMax: 180000,
};

const devStripeKey = 'pk_test_fJzi8lcnQbbKhlMJp9YVZ2tA00Wx6NIMm2';
const stripePublishableKey = process.env.STRIPE_PUBLISHABLE_KEY;
const googleApiKey = process.env.GOOGLE_API_KEY;
const freshChatToken = process.env.FRESHCHAT_TOKEN;
const voiceflowProjectId = process.env.VOICEFLOW_PROJECT_ID;
const voiceflowVersionIdProd = 'production';
const voiceflowVersionIdNonProd = 'development';

const utrStripeAccountId = process.env.UTR_STRIPE_ACCOUNT_ID || 'acct_1AV2NnBJJJ7ji1oI';

const prodSegmentKey = 'XJQ5EvgdaXEKA7B8XgaiPgOPWjO0GB2Q';
const nonProdSegmentKey = 'kGabTpvRe2bSYtu4QmKKmoPf5Q6kY2Xc';

const prodStatSigKey = 'client-4LAt4G2WF7YyknVbpYC85wOlhGMXFFzsUweyf9wdYkl';
const devStatSigKey = 'client-dkpMtHXA3pht1FYZ0gDEAEiWhmBGAIFpiUMeRUNGyQj';

const prodFacebookPixelId = '934768840401987';
const nonProdFacebookPixelId = '123456789123456';

const devBrazeApiKey = '76f41316-8f54-49d2-968f-9b6c6cdbb8d4';
const prodBrazeApiKey = '39f28a45-a4c7-4fec-a1de-56fa1fed9ba6';

const localDevSettings = {
    appHost: 'https://localhost:3443',
    appHostName: 'localhost',
    marketingAppHost: 'http://localhost:3001',
    nextAppHost: 'http://localhost:3003',
    apiHost: `https://test1-api.${rootDomain}`,
    leaguesApiHost: `https://test1-leagues-api.${rootDomain}`,
    leaguesSearchApiHost: getSearchApiHost('development'),
    groupsApiHost: `https://test10-groups-api.${rootDomain}`,
    engageApiHost: 'http://localhost:24241',
    rostersApiHost: `https://dev-rosters-api.${rootDomain}`,
    rankingsApiHost: `https://dev-rankings-api.${rootDomain}`,
    utrStatsApiHost: 'https://dev-utr-volumetric-stats-eastus-data-azapp.azurewebsites.net/',
    searchApiHost: getSearchApiHost('development'),
    liveScoresApiHost: 'https://dev-utr-ptt-livescores-eastus-data-func.azurewebsites.net/api',
    leaguesAppHost: 'https://localhost:3443',
    leaguesAppHostName: 'localhost',
    userSiteHost: 'https://localhost:44300',
    userSiteHostName: 'localhost',
    siteBaseUrl: rootDomain,
    brandedUrl: brandedDomain,
    twitterAccount: twitterHandle,
    fontUrl: localFontUrl,
    stripeHost: 'https://connect.stripe.com',
    stripeClientId: 'ca_G7kABhwUKLT9L05CMvE33btClNTT5xvn',
    stripeKey: devStripeKey,
    utrStripeAccountId,
    messaging,
    alwaysUseProxy: true,
    publicPath: webServerPublicPath,
    enableAnalytics: true,
    oldLogoClubIds,
    pixelId: nonProdFacebookPixelId,
    cdnUrl: `https://ci-cdn.${rootDomain}`,
    isLocalhost: true,
    appleClientId: 'com.universaltennis.web-test8',
    statsigKey: devStatSigKey,
    defaultTitle,
    googleApiKey,
    brazeApiKey: devBrazeApiKey,
    brazeEnableLogging: true,
    freshChatToken,
    voiceflowProjectId,
    voiceflowVersionId: voiceflowVersionIdNonProd,
    collegeCornerAd: true,
    ...localConfig,
};

function toShortEnv(environmentName) {
    const env = String(environmentName).toLowerCase();
    if (/^test[1-6]$/.test(env)) {
        return 'dev';
    }

    if (env === 'qa' || env === 'uat') {
        return 'qa';
    }

    return env;
}

// Search API is only deployed to prod, qa, and dev.
// All test[x] environments fall back to the dev Search API host.
function getSearchApiHost(environmentName) {
    if (process.env.SEARCHAPIHOST) {
        return process.env.SEARCHAPIHOST;
    }
    const env = String(environmentName).toLowerCase();
    if (env === 'prod' || env === 'production') {
        return `https://api.${rootDomain}`;
    }
    if (env === 'qa' || env === 'uat') {
        return 'https://qa-utr-search-api-v2-eastus-platform-azapp.azurewebsites.net';
    }
    // dev, test1-test6, and anything else → dev search host
    return 'https://dev-utr-search-api-v2-eastus-platform-azapp.azurewebsites.net';
}

function envCDNUrl(environmentName) {
    const env = String(environmentName).toLowerCase();
    const isTestEnv = /^test[1-6]$/.test(env);
    const isRc = ['rc'].indexOf(env) > -1;

    let cdnUrl;
    if (isRc) {
        cdnUrl = `https://ci-cdn.${rootDomain}`;
    } else if (isTestEnv || env === 'dev') {
        cdnUrl = `https://${env}-api.${rootDomain}`;
    } else {
        cdnUrl = `https://${env}-cdn.${rootDomain}`;
    }

    let cdnUrlStatic;
    if (env === 'dev') {
        cdnUrlStatic = 'https://utrdev.z13.web.core.windows.net';
    } else if (isTestEnv) {
        cdnUrlStatic = `https://ut${env}.z13.web.core.windows.net`;
    } else {
        cdnUrlStatic = `https://${env}-cdn-static.${rootDomain}`;
    }

    return { cdnUrl, cdnUrlStatic };
}

const createTestSettings = (environmentName) => {
    const shortEnv = toShortEnv(environmentName);
    const environmentPrefix = environmentName === 'qa' ? 'qa' : 'dev';
    const { cdnUrl, cdnUrlStatic } = envCDNUrl(environmentName);
    const apiUri = process.env.APIHOST || `https://${environmentName}-api.${rootDomain}`;
    const leaguesApiUri = process.env.LEAGUESAPIHOST || `https://${environmentName}-leagues-api.${rootDomain}`;
    const groupsApiUri = process.env.GROUPSAPIHOST || `https://${environmentName}-groups-api.${rootDomain}`;
    const leaguesSearchApiUri = getSearchApiHost(environmentName);
    const engageApiUri = process.env.ENGAGEAPIHOST || `https://${environmentPrefix}-utr-engage-api-data-azapp.azurewebsites.net/`;
    const rostersApiUri = process.env.ROSTERSAPIHOST || `https://${environmentPrefix}-rosters-api.${rootDomain}`;
    const rankingsApiUri = process.env.RANKINGSAPIHOST || `https://${shortEnv}-rankings-api.${rootDomain}`;
    const utrStatsApiUri = process.env.UTRSTATSAPIHOST || `https://${shortEnv}-utr-volumetric-stats-eastus-data-azapp.azurewebsites.net/`;
    const liveScoresApiUri = process.env.LIVESCORESAPIHOST || `https://${shortEnv}-utr-ptt-livescores-eastus-data-func.azurewebsites.net/api`;
    const searchApiUri = getSearchApiHost(environmentName);

    return {
        siteBaseUrl: process.env.siteBaseUrl || rootDomain,
        brandedUrl: process.env.brandedUrl || brandedDomain,
        twitterAccount: process.env.twitterAccount || twitterHandle,
        appHost: process.env.APPHOST || `https://${environmentName}-app.${rootDomain}`,
        appHostName: process.env.APPHOSTNAME || `https://${environmentName}-app.${rootDomain}`,
        leaguesAppHost: process.env.LEAGUES_APP_HOST || `https://${environmentName}-leagues.${rootDomain}`,
        leaguesAppHostName: process.env.LEAGUES_APP_HOST_NAME || `${environmentName}-leagues.${rootDomain}`,
        marketingAppHost: `https://${rootDomain}`,
        nextAppHost: nextAppUrl('dev'),
        apiHost: apiUri,
        leaguesApiHost: leaguesApiUri,
        groupsApiHost: groupsApiUri,
        messagingApiHost: `https://${shortEnv}-utr-messaging-api-eastus-platform-azapp.azurewebsites.net`,
        leaguesSearchApiHost: leaguesSearchApiUri,
        rankingsApiHost: rankingsApiUri,
        utrStatsApiHost: utrStatsApiUri,
        searchApiHost: searchApiUri,
        liveScoresApiHost: liveScoresApiUri,
        engageApiHost: engageApiUri,
        rostersApiHost: rostersApiUri,
        userSiteHost: process.env.USERSITEHOST || `https://${environmentName}-app.${rootDomain}`,
        userSiteHostName: process.env.USERSITEHOST || `${environmentName}-app.${rootDomain}`,
        fontUrl: process.env.FONTURL || devFontUrl,
        stripeHost: 'https://connect.stripe.com',
        stripeClientId: 'ca_G7kABhwUKLT9L05CMvE33btClNTT5xvn',
        stripeKey: stripePublishableKey,
        googleApiKey,
        utrStripeAccountId,
        messaging,
        cdnUrl: process.env.CDN_URL || cdnUrl,
        publicPath: urljoin(cdnUrlStatic, configConstants.outputPath, configConstants.appCodePath),
        segmentKey: nonProdSegmentKey,
        oldLogoClubIds,
        enableAnalytics: true,
        devtoolConfig: 'source-map',
        pixelId: nonProdFacebookPixelId,
        appleClientId: 'com.universaltennis.web-test8',
        statsigKey: devStatSigKey,
        defaultTitle,
        brazeApiKey: devBrazeApiKey,
        brazeEnableLogging: true,
        freshChatToken,
        voiceflowProjectId,
        voiceflowVersionId: voiceflowVersionIdNonProd,
        collegeCornerAd: true,
    };
};

const prodApiUri = process.env.APIHOST || `https://api.${rootDomain}`;
const prodLeaguesApiUri = process.env.LEAGUESAPIHOST || `https://leagues-api.${rootDomain}`;
const prodGroupsApiUri = process.env.GROUPSAPIHOST || `https://groups-api.${rootDomain}`;
const prodLeaguesSearchApiUri = process.env.SEARCH_API_HOST || `https://api.${rootDomain}`;
const prodEngageApiUri = process.env.ENGAGEAPIHOST || 'https://prod-utr-engage-api-data-azapp.azurewebsites.net/';
const prodRostersApiUri = process.env.ROSTERSAPIHOST || `https://rosters-api.${rootDomain}`;
const prodRankingsApiUri = process.env.RANKINGSAPIHOST || `https://rankings-api.${rootDomain}`;
const prodSearchApiUri = getSearchApiHost('prod');
const prodUtrStatsApiUri = process.env.UTRSTATSAPIHOST || prodApiUri;
const prodLiveScoresApiUri = process.env.LIVESCORESAPIHOST || `https://prod-utr-ptt-livescores-eastus-data-func.azurewebsites.net/api`;
const prodCdnUrl = process.env.CDN_URL || `https://prod-cdn.${rootDomain}`;
const prodCdnStaticUrl = process.env.CDN_URL_STATIC || `https://prod-cdn-static.${rootDomain}`;
const prodServerSettings = {
    siteBaseUrl: process.env.siteBaseUrl || rootDomain,
    brandedUrl: process.env.brandedUrl || brandedDomain,
    twitterAccount: process.env.twitterAccount || twitterHandle,
    appHost: process.env.APPHOST || `https://app.${rootDomain}`,
    appHostName: process.env.APPHOSTNAME || `app.${rootDomain}`,
    leaguesAppHost: process.env.LEAGUES_APP_HOST || `https://leagues.${rootDomain}`,
    leaguesAppHostName: process.env.LEAGUES_APP_HOST_NAME || `leagues.${rootDomain}`,
    marketingAppHost: process.env.MARKETINGAPPHOST || `https://${rootDomain}`,
    nextAppHost: process.env.APPHOST || `https://app.${rootDomain}`,
    apiHost: prodApiUri,
    leaguesApiHost: prodLeaguesApiUri,
    leaguesSearchApiHost: prodLeaguesSearchApiUri,
    messagingApiHost: prodApiUri, // in Prod this goes through FD and routed by path to the backend pools. So this stays prodApi
    groupsApiHost: prodGroupsApiUri,
    rankingsApiHost: prodApiUri, // in Prod this goes through FD and routed by path to the backend pools. So this stays prodApi
    utrStatsApiHost: prodUtrStatsApiUri,
    searchApiHost: prodSearchApiUri,
    liveScoresApiHost: prodLiveScoresApiUri,
    engageApiHost: prodEngageApiUri,
    rostersApiHost: prodApiUri, // in Prod this goes through FD and routed by path to the backend pools. So this stays prodApi
    userSiteHost: process.env.USERSITEHOST || `https://app.${rootDomain}`,
    userSiteHostName: process.env.USERSITEHOST || `app.${rootDomain}`,
    fontUrl: process.env.FONTURL || prodFontUrl,
    stripeHost: 'https://connect.stripe.com',
    stripeClientId: process.env.STRIPE_CLIENT_ID || 'ca_G7kArGiIoboxUDj62elK8kxXinfQe0QI',
    stripeKey: stripePublishableKey,
    googleApiKey,
    utrStripeAccountId,
    messaging: process.env.MESSAGING || messagingProd,
    cdnUrl: prodCdnUrl,
    publicPath: urljoin(prodCdnStaticUrl, configConstants.outputPath, configConstants.appCodePath),
    segmentKey: prodSegmentKey,
    oldLogoClubIds,
    enableAnalytics: true,
    devtoolConfig: false,
    pixelId: prodFacebookPixelId,
    appleClientId: 'com.universaltennis.web',
    statsigKey: prodStatSigKey,
    defaultTitle,
    brazeApiKey: prodBrazeApiKey,
    brazeEnableLogging: false,
    freshChatToken,
    voiceflowProjectId,
    voiceflowVersionId: voiceflowVersionIdProd,
    collegeCornerAd: true,
    alwaysUseProxy: process.env.ALWAYS_USE_PROXY || false,
};

const prodDebugSettings = {
    siteBaseUrl: process.env.siteBaseUrl || rootDomain,
    brandedUrl: process.env.brandedUrl || brandedDomain,
    twitterAccount: process.env.twitterAccount || twitterHandle,
    appHost: process.env.APPHOST || `https://app-debug.${rootDomain}`,
    appHostName: process.env.APPHOSTNAME || `app-debug.${rootDomain}`,
    marketingAppHost: process.env.MARKETINGAPPHOST || `https://${rootDomain}`,
    nextAppHost: process.env.APPHOST || `https://app-debug.${rootDomain}`,
    apiHost: prodApiUri,
    leaguesApiHost: prodLeaguesApiUri,
    leaguesSearchApiHost: prodLeaguesSearchApiUri,
    groupsApiHost: prodGroupsApiUri,
    rankingsApiHost: prodRankingsApiUri,
    utrStatsApiHost: prodUtrStatsApiUri,
    searchApiHost: prodSearchApiUri,
    liveScoresApiHost: prodLiveScoresApiUri,
    engageApiHost: prodEngageApiUri,
    rostersApiHost: prodRostersApiUri,
    userSiteHost: process.env.USERSITEHOST || `https://app-debug.${rootDomain}`,
    userSiteHostName: process.env.USERSITEHOST || `app-debug.${rootDomain}`,
    fontUrl: process.env.FONTURL || prodFontUrl,
    stripeHost: 'https://connect.stripe.com',
    stripeClientId: process.env.STRIPE_CLIENT_ID || 'ca_G7kArGiIoboxUDj62elK8kxXinfQe0QI',
    stripeKey: stripePublishableKey,
    googleApiKey,
    utrStripeAccountId,
    messaging,
    cdnUrl: prodCdnUrl,
    publicPath: prodCdnStaticUrl,
    segmentKey: prodSegmentKey,
    oldLogoClubIds,
    enableAnalytics: true,
    devtoolConfig: 'source-map',
    pixelId: prodFacebookPixelId,
    appleClientId: '',
    statsigKey: prodStatSigKey,
    defaultTitle,
    brazeApiKey: prodBrazeApiKey,
    brazeEnableLogging: false,
    freshChatToken,
    voiceflowProjectId,
    voiceflowVersionId: voiceflowVersionIdNonProd,
    collegeCornerAd: true,
};

const qaServerSettings = createTestSettings('qa');
const uatServerSettings = createTestSettings('uat');
const test1ServerSettings = createTestSettings('test1');
const test2ServerSettings = createTestSettings('test2');
const test3ServerSettings = createTestSettings('test3');
const test4ServerSettings = createTestSettings('test4');
const test5ServerSettings = createTestSettings('test5');
const test6ServerSettings = createTestSettings('test6');
const devServerSettings = createTestSettings('dev');

qaServerSettings.nextAppHost = nextAppUrl('qa');

// prod font: https://cloud.typography.com/6323816/6355392/css/fonts.css

// eslint-disable-next-line import/no-mutable-exports
let config = localDevSettings; // Default to local dev settings

const configSource = (process.env.CONFIG_SOURCE || 'development').toLowerCase();

switch (configSource) {
    case 'prod':
    case 'production':
        config = prodServerSettings;
        break;
    case 'qa':
        config = qaServerSettings;
        break;
    case 'uat':
        config = uatServerSettings;
        // UAT environment uses QA leagues
        config.leaguesApiHost = `https://qa-leagues-api.${rootDomain}`;
        config.leaguesAppHostName = `qa-leagues.${rootDomain}`;
        break;
    case 'test1':
        config = test1ServerSettings;
        break;
    case 'test2':
        config = test2ServerSettings;
        break;
    case 'test3':
        config = test3ServerSettings;
        break;
    case 'test4':
        config = test4ServerSettings;
        break;
    case 'test5':
        config = test5ServerSettings;
        break;
    case 'test6':
        config = test6ServerSettings;
        break;
    case 'dev':
        config = devServerSettings;
        break;
    case 'prod-debug':
        config = prodDebugSettings;
        break;
    default:
        config = localDevSettings;
}

// Common settings
config.outputPath = configConstants.outputPath;
config.appCodePath = configConstants.appCodePath;
config.applicationVersion = configConstants.applicationVersion;
config.staticContentPath = configConstants.staticContentPath;
config.searchDebounceMilliseconds = configConstants.searchDebounceMilliseconds;
config.voiceflowVersionId = config.voiceflowVersionId || 0;

// Using this instead of ES6 syntax for compatibility with node
module.exports = config;
module.exports._getSearchApiHost = getSearchApiHost;
